import { createApi } from '@reduxjs/toolkit/query/react';
import { ReferralRewards, TierLevels, ServiceCommission } from './types';
import baseQuery from '../baseQuery';
import { whitelabel } from '../../whitelabel';

export const api = createApi({
  baseQuery: baseQuery(whitelabel.baseReferralApi),
  reducerPath: 'referralApi',
  tagTypes: ['Referrals', 'Commission'],
  endpoints: (builder) => ({
    referralRewards: builder.query<ReferralRewards, void>({
      query: () => ({
        url: 'v1/referrer/data',
      }),
      providesTags: ['Referrals'],
    }),
    tierLevels: builder.query<TierLevels, void>({
      query: () => ({
        url: 'v1/tier-levels',
      }),
    }),
    serviceCommission: builder.query<ServiceCommission, { serviceId: string }>({
      query: ({ serviceId }) => ({
        url: `v1/service/commission/${serviceId}`,
      }),
      providesTags: ['Commission'],
    }),
  }),
});

export const {
  useReferralRewardsQuery,
  useTierLevelsQuery,

  useServiceCommissionQuery,
} = api;
